import React from 'react';
import ReactDOM from 'react-dom';
import { WixBaseUiEnvironmentProvider } from '@wix/wix-base-ui';

const portalRoot = window.document.body;

interface DropDownPortalProps {}

const DropDownPortal: React.FC<DropDownPortalProps> = (props) => {
  const component = (
    <WixBaseUiEnvironmentProvider madefor theme="facelift" inputBorders={true}>
      <div className="top-bar-drop-down-portal-wrapper">{props.children}</div>
    </WixBaseUiEnvironmentProvider>
  );
  return ReactDOM.createPortal(component, portalRoot);
};

export default DropDownPortal;
